<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import Badge from 'primevue/badge'
import { useCommerceStore } from '~/stores/pos/commerce'

const commerceStore = useCommerceStore()
const posCheckStore = usePosCheckStore()
const businessStore = useBusinessStore()

const {
  itemsInCart: commerceItems,
  openCart,
} = storeToRefs(commerceStore)

const { itemsInCart: checkItems, hasActiveCheck, selectedTable } = storeToRefs(posCheckStore)
const { parkCheck } = posCheckStore
const { businessInfo } = storeToRefs(businessStore)
const { t } = useNuxtApp().$i18n

const totalItemsInCart = computed(() => {
  return hasActiveCheck.value ? checkItems.value : commerceItems.value
})

const isRestaurantMode = computed(() => businessInfo.value?.service_type === 'restaurant')
const showTableInfo = computed(() => isRestaurantMode.value && hasActiveCheck.value && selectedTable.value)
</script>

<template>
  <ul class="m-0 flex list-none p-0 items-center gap-2">
    <!-- Select Table Button (Restaurant Mode Only, Hidden on Mobile) -->
    <li
      v-if="isRestaurantMode && hasActiveCheck"
      class="hidden md:flex"
    >
      <Button
        :label="t('Select table or customer')"
        icon="pi pi-table"
        severity="secondary"
        outlined
        size="small"
        @click="parkCheck"
      />
    </li>

    <!-- Table Info (Restaurant Mode Only, Hidden on Mobile) -->
    <li
      v-if="showTableInfo"
      class="hidden md:flex items-center gap-2 bg-white px-3 py-2 rounded-lg shadow-sm"
    >
      <i class="pi pi-table text-gray-700" />
      <span class="font-semibold text-gray-900">
        {{ selectedTable?.table_number }}
      </span>
    </li>

    <!-- Cart Button -->
    <li class="flex">
      <Button
        class="p-ripple inline-flex cursor-pointer items-center rounded-none border-0 px-2 font-medium sm:px-3 bg-teal-100 text-black hover:text-primary"
        @click="openCart = true"
      >
        <i
          class="pi pi-shopping-cart text-[28px]"
        />
        <span v-if="totalItemsInCart">
          <Badge
            :value="totalItemsInCart"
            severity="danger"
            size="large"
            class=" h-[1.4rem] min-w-[1.4rem] leading-[1.4rem]"
          />
        </span>
        <span class="hidden">Cart</span>
      </Button>
    </li>
  </ul>
</template>
